import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AssetComponent } from '../.././pages/asset/asset.component';
import { ContractsComponent } from '../.././pages/contracts/contracts.component';
import { ContractsDeploymentComponent } from '../.././pages/contracts-deployment/contracts-deployment.component';
import { ContractsTriggersComponent } from '../.././pages/contracts-triggers/contracts-triggers.component';
import { AccountComponent } from '../.././pages/account/account.component';
import { BackupwalletComponent } from '../.././pages/backupwallet/backupwallet.component';
import { BlockComponent } from '../.././pages/block/block.component';
import { BlocksidComponent } from '../.././pages/blocksid/blocksid.component';
import { FinishPasswordComponent } from '../.././pages/finish-password/finish-password.component';
import { MultiSignatureComponent } from '../.././pages/multi-signature/multi-signature.component';
import { RecordTokenComponent } from '../.././pages/record-token/record-token.component';
import { TagComponent } from '../.././pages/tag/tag.component';

import { RewardsecComponent } from '../.././pages/rewardsec/rewardsec.component';
import { BasicLayoutComponent } from './basic-layout.component';
import { TransactiondetailsComponent } from 'src/app/pages/transactiondetails/transactiondetails.component';
import { AccountDetailsComponent } from 'src/app/pages/account-details/account-details.component';
import { AuthguardGuard } from 'src/app/guards/authguard.guard';
import { TransactionHistoryComponent } from 'src/app/pages/transaction-history/transaction-history.component';
import { TokenTransfersComponent } from 'src/app/pages/token-transfers/token-transfers.component';
import { FreezeHistoryComponent } from 'src/app/pages/freeze-history/freeze-history.component';
import { WithdrawHistoryComponent } from 'src/app/pages/withdraw-history/withdraw-history.component';
import { BlockHashComponent } from 'src/app/pages/block-hash/block-hash.component';
import { AddressComponent } from 'src/app/pages/address/address.component';
import { TransDetailsComponent } from 'src/app/pages/trans-details/trans-details.component';
import { TokenComponent } from 'src/app/pages/token/token.component';
import { SrprofileComponent } from 'src/app/pages/srprofile/srprofile.component';
import { UnfreezeHistoryComponent } from 'src/app/pages/unfreeze-history/unfreeze-history.component';


export const BasicLayoutRoutes: Routes = [
  {
    path: '', component: BasicLayoutComponent,
    children: [
      {
        path: 'asset', component: AssetComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'contracts', component: ContractsComponent,
      },
      { path: 'transaction-info/:txid', component: TokenComponent },

      {
        path: 'contracts-deployment', component: ContractsDeploymentComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'contracts-triggers/:address/:name', component: ContractsTriggersComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'contracts-triggers/:name/:address', component: ContractsTriggersComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'address/:address', component: AddressComponent
      },
      {
        path: 'account', component: AccountComponent,
      },
      {
        path: 'block', component: BlockComponent,
      },
      {
        path: 'transaction-history', component: TransactionHistoryComponent,
      },
      {
        path: 'blocksid/:id', component: BlocksidComponent,
      },
      {
        path: 'blocksid', component: BlocksidComponent,
      },
      {
        path: 'freeze-history', component: FreezeHistoryComponent,
      },
      {
        path: 'unfreeze-history', component: UnfreezeHistoryComponent,
      },
      {
        path: 'withdraw-history', component: WithdrawHistoryComponent,
      },

      {
        path: 'multi-signature', component: MultiSignatureComponent,
      },
      {
        path: 'record-token', component: RecordTokenComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'account-details/:address', component: AccountDetailsComponent
      },
      {
        path: 'contract-methods/:address/:name', component: RewardsecComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'contract-methods/:address', component: RewardsecComponent,
        canActivate: [AuthguardGuard]
      },
      {
        path: 'contract-methods/:address/:name/contract', component: RewardsecComponent,
        canActivate: [AuthguardGuard]
      },
      { path: 'trans-details/:id', component: TransDetailsComponent },
      { path: 'trans-details/:id/:name', component: TransDetailsComponent },

      {
        path: 'transactiondetails/:txid', component: TransactiondetailsComponent,
      },
      {
        path: 'transactiondetails', component: TransactiondetailsComponent,
      },
      {
        path: 'transfers', component: TokenTransfersComponent,
      },
      {
        path: 'block-hash/:hash', component: BlockHashComponent,
      },
      { path: 'tag/:type/:search', component: TagComponent },
    ]
  },

];



export const layoutRoutings = [AssetComponent, ContractsComponent, ContractsDeploymentComponent, ContractsTriggersComponent, AccountComponent, BackupwalletComponent, BlockComponent, BlocksidComponent, FinishPasswordComponent, MultiSignatureComponent, RecordTokenComponent, TagComponent, RewardsecComponent, BlockHashComponent, AccountDetailsComponent, AddressComponent, TransDetailsComponent, TokenComponent]; 
